var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',[_c('v-card-title',[_vm._v("Upload Shelter List")]),_c('v-card-text',[_c('UploadCSV',{attrs:{"isDialog":true},on:{"close":_vm.close}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }